import { shape, instanceOf } from 'prop-types'

const calendarDateClickType = shape({
  end: instanceOf(Date),
  start: instanceOf(Date),
})

export default calendarDateClickType
